import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../SalesReturnLedgerSlice";
import {
  fetchSalesReturnLedger,
  fetchSaleReturnAccounts,
} from "../SalesReturnLedgerThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";

import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";

const SalesReturnLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, accounts } = useSelector((state) => state.salesReturnLedger);

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchSaleReturnAccounts());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchSalesReturnLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            optionsList={accounts.map((c) => ({
              sale_id: c.acc_id,
              display_text: c.acc_name,
            }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default SalesReturnLedgerFilters;
